
import React from 'react';
import { EnrichedVisitor } from "@/types/database";

interface ContactInformationProps {
  visitor: EnrichedVisitor;
}

const ContactInformation = ({ visitor }: ContactInformationProps) => {
  const hasContactInfo = visitor.emails?.length || 
                        visitor.personal_emails?.length || 
                        visitor.work_email || 
                        visitor.mobile_phone || 
                        visitor.recommended_personal_email;

  if (!hasContactInfo) return null;

  return (
    <div className="mt-2 space-y-3 border p-3 rounded-md bg-blue-50 w-full">
      <p className="text-sm font-medium text-blue-700">Available Contact Details</p>
      
      {visitor.work_email && (
        <div className="w-full">
          <p className="text-xs text-blue-600">Work Email</p>
          <p className="text-sm break-all">{visitor.work_email}</p>
        </div>
      )}
      
      {visitor.recommended_personal_email && (
        <div className="w-full">
          <p className="text-xs text-blue-600">Personal Email</p>
          <p className="text-sm break-all">{visitor.recommended_personal_email}</p>
        </div>
      )}
      
      {visitor.mobile_phone && (
        <div className="w-full">
          <p className="text-xs text-blue-600">Mobile Phone</p>
          <p className="text-sm">{visitor.mobile_phone}</p>
        </div>
      )}
      
      {visitor.emails && visitor.emails.length > 0 && (
        <div className="w-full">
          <p className="text-xs text-blue-600">All Emails ({visitor.emails.length})</p>
          <div className="mt-1 max-h-24 overflow-y-auto w-full">
            {visitor.emails.map((email, idx) => (
              <p key={idx} className="text-sm break-all">{email}</p>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default ContactInformation;
